// extracted by mini-css-extract-plugin
export default {"mainPageWrapper":"noAccessPage_mainPageWrapper__LQctC","redirectionAction":"noAccessPage_redirectionAction__f8lrQ"};